import React from 'react';

import {SmallChat, ActiveUsersService} from 'Components/Networking/Sub';

import ToApi from 'Services/Api/Networking/To';

import {translation} from 'Services/TranslationHelpers';

export default class StandaloneChat extends React.Component {
    /**
     * @var state
     */
    state = {
        selected_chat: null,
        error_message: null
    }

    /**
     * @method componentDidMount
     */
    componentDidMount() {
        ActiveUsersService.subscribe();

        this.setSelectedChatOnLoad();
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount() {
        ActiveUsersService.unsubscribe();
    }

    /**
     * @method setSelectedChatOnLoad
     */
    setSelectedChatOnLoad = async () => {
        const {selectedMessageToType, selectedMessageToId} = this.props;

        if (selectedMessageToType && selectedMessageToId) {
            const response = await ToApi.get(selectedMessageToId, {
                message_to_type: selectedMessageToType
            });

            if (response.success) {
                this.setSelectedChat(response.data.data);
            } else {
                this.setState({
                    error_message: 'Invalid pre-select'
                });
            }
        }
    }

    /**
     * @method setSelectedChat
     * @param {object} chat
     */
    setSelectedChat = (chat) => {
        this.setState({
            selected_chat: chat
        });
    }

    /**
     * @method render
     * @return {*}
     */
    render() {
        const {selected_chat, error_message} = this.state;
        const {chatMaxHeight} = this.props

        if (error_message) {
            return (
                <div className="text-center font-bold">
                    {error_message}
                </div>
            );
        }

        return (
            <div className="networking-container h-full flex flex-col lg:flex-row">
                <div className="flex min-w-full">
                    <div className="w-full">
                        <SmallChat
                            setSelectedChat={(chat) => this.setSelectedChat(chat)}
                            selected_chat={selected_chat}
                            chatMaxHeight={chatMaxHeight}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
